import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useCurrentUser } from '#src/app/shared/hooks/session';

/**
 * Guests have no session user, so their name only arrives as the `short_display_name` param forwarded by
 * the previous PSF step. No generic fallback: without a name the counter uses its no-name copy.
 */
export function useSupporterName(): string | undefined {
	const user = useCurrentUser();
	const shortDisplayNameParam = useQueryParamValue('short_display_name');

	return user?.firstName || user?.shortDisplayName || shortDisplayNameParam || undefined;
}
